import { AccountStatementRecord, AccountSummaryRecord } from "records/account-view-record";
import { ACCOUNT_VIEW_ACTIONS } from "constants/actions";
import { STATE_STATUS } from "constants";
import { Map, List } from "immutable";

const INITIAL_STATE = new Map({
    accountSummary: new Map({
        status: STATE_STATUS.UNFETCHED,
        data: null
    }),
    accountStatement: new Map({
        status: STATE_STATUS.UNFETCHED,
        data: null
    }),
    openInvoices: new Map({
        status: STATE_STATUS.UNFETCHED,
        data: null
    })
});

export default (state = INITIAL_STATE, { type, payload }) => {
    switch(type) {
    case ACCOUNT_VIEW_ACTIONS.FETCH_ACCOUNT_SUMMARY:
        return state
            .setIn(["accountSummary", "status"], STATE_STATUS.FETCHING)
            .setIn(["accountSummary", "data"], new AccountSummaryRecord());
    case ACCOUNT_VIEW_ACTIONS.FETCHED_ACCOUNT_SUMMARY:
        return state
            .setIn(["accountSummary", "status"], STATE_STATUS.FETCHED)
            .setIn(["accountSummary", "data"], new AccountSummaryRecord(payload.data));
    case ACCOUNT_VIEW_ACTIONS.FAILED_FETCH_ACCOUNT_SUMMARY:
        return state.setIn(["accountSummary", "status"], STATE_STATUS.FETCH_FAILED);
    
    case ACCOUNT_VIEW_ACTIONS.FETCH_ACCOUNT_STATEMENT:
        return state.setIn(["accountStatement", "status"], STATE_STATUS.FETCHING);
    case ACCOUNT_VIEW_ACTIONS.FETCHED_ACCOUNT_STATEMENT:
        return state
            .setIn(["accountStatement", "status"], STATE_STATUS.FETCHED)
            .setIn(["accountStatement", "data"], payload.data && 
            new List(
                payload.data.map(_ => new AccountStatementRecord(_)))
            );
    case ACCOUNT_VIEW_ACTIONS.FAILED_FETCH_ACCOUNT_STATEMENT:
        return state.setIn(["accountStatement", "status"], STATE_STATUS.FETCH_FAILED);
    case ACCOUNT_VIEW_ACTIONS.FETCH_FACILITY_ACCOUNT_OPEN_INVOICES:
        return state.setIn(["openInvoices", "status"], STATE_STATUS.FETCHING);
    case ACCOUNT_VIEW_ACTIONS.FETCHED_FACILITY_ACCOUNT_OPEN_INVOICES:
        return state
            .setIn(["openInvoices", "status"], STATE_STATUS.FETCHED)
            .setIn(["openInvoices", "data"], new List(payload.data).toMap().mapEntries(([, v]) => [v.id, v]));
    case ACCOUNT_VIEW_ACTIONS.FAILED_FETCH_FACILITY_ACCOUNT_OPEN_INVOICES:
        return state.setIn(["openInvoices", "status"], STATE_STATUS.FETCH_FAILED);
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};
